import {
    policyTipsClassificationInfoLabel,
    policyTipsMoreDetailsLinkLabel,
    policyTipsMoreDetailsLink,
    policyTipsReportFalsePositiveLabel,
    policyTipsReportFalsePositiveButton,
} from './PolicyTipsPeek.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import getInfoBarLinkColorStyle from 'owa-info-bar/lib/utils/getInfoBarLinkColorStyle';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import setIsFalsePositive from '../actions/setIsFalsePositive';

import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getHighestPriorityPolicyTipMatchDetail } from '../utils/getHighestPriorityPolicyTipMatchDetail';
import { observer } from 'mobx-react';

const classNames = require('classnames');
const styles = require('./PolicyTipsPeek.scss');

export interface PolicyTipsPeekProps {
    viewState: PolicyTipsViewState;
}

@observer
export default class PolicyTipsPeek extends React.Component<PolicyTipsPeekProps, any> {
    private openUrl = (url: string) => () => {
        window.open(url, '_blank');
    };

    private onReportFalsePositiveClicked = () => {
        setIsFalsePositive(this.props.viewState, true);
    };
    render() {
        const {
            complianceUrl,
            succeededPolicyMatch,
            isReportedFalsePositive,
        } = this.props.viewState;
        const matchDetail = getHighestPriorityPolicyTipMatchDetail(succeededPolicyMatch);
        const linkStyle = classNames(styles.link, getInfoBarLinkColorStyle(null));
        return (
            <div className={styles.policyTipPeekContainer}>
                {matchDetail.Classifications && (
                    <div>
                        <span>{loc(policyTipsClassificationInfoLabel)}</span>
                        <ul>
                            {matchDetail.Classifications.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                )}
                {complianceUrl && complianceUrl.length > 0 && (
                    <div>
                        <span>{loc(policyTipsMoreDetailsLinkLabel)}</span>{' '}
                        <a className={linkStyle} onClick={this.openUrl(complianceUrl)}>
                            {loc(policyTipsMoreDetailsLink)}
                        </a>
                    </div>
                )}
                {!isReportedFalsePositive && (
                    <div>
                        <label htmlFor={'reportButton'}>
                            {loc(policyTipsReportFalsePositiveLabel)}
                        </label>
                        <div className={styles.policyTipButtonContainer}>
                            <DefaultButton
                                id={'reportButton'}
                                onClick={this.onReportFalsePositiveClicked}
                                text={loc(policyTipsReportFalsePositiveButton)}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
